import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'react-bootstrap';
import { bootstrapUtils } from 'react-bootstrap/lib/utils';
import moment from 'moment';
import './OverviewFlight.css';
import EventEmitter from '../../modules/event-emitter/EventEmitter';
import ImageFallback from '../../common/imageFallback/ImageFallback';

bootstrapUtils.addStyle(Button, 'change-search');

const I18n = require('i18n-react').default;

const propTypes = {
  id: PropTypes.string.isRequired,
  alterFlight: PropTypes.bool.isRequired,
  departureFlight: PropTypes.shape({
    flightDate: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    flight: PropTypes.shape({
      flightGroup: PropTypes.arrayOf(
        PropTypes.shape({
          flightNumber: PropTypes.number.isRequired,
          origin: PropTypes.string.isRequired,
          destination: PropTypes.string.isRequired,
          departureTime: PropTypes.string.isRequired,
          arrivalTime: PropTypes.string.isRequired,
          dateVariation: PropTypes.number,
          operatingCarrier: PropTypes.string.isRequired,
          throughFlight: PropTypes.bool
        })
      )
    })
  }),
  returnFlight: PropTypes.shape({
    flightDate: PropTypes.string,
    category: PropTypes.string.isRequired,
    flight: PropTypes.shape({
      flightGroup: PropTypes.arrayOf(
        PropTypes.shape({
          flightNumber: PropTypes.number,
          origin: PropTypes.string,
          destination: PropTypes.string,
          departureTime: PropTypes.string,
          arrivalTime: PropTypes.string,
          dateVariation: PropTypes.number,
          operatingCarrier: PropTypes.string,
          throughFlight: PropTypes.bool
        })
      )
    })
  })
};

const ALTER_DEPARTURE_FLIGHT_EVENT = 'alter-departure-flight-overview';
const ALTER_RETURN_FLIGHT_EVENT = 'alter-return-flight-overview';

class OverviewFlight extends React.Component {
  constructor(props) {
    super(props);

    this.renderConnections = this.renderConnections.bind(this);
  }

  alterFlight(isReturnFlight) {
    if (isReturnFlight) {
      EventEmitter.emitEvent(ALTER_RETURN_FLIGHT_EVENT);
    } else {
      EventEmitter.emitEvent(ALTER_DEPARTURE_FLIGHT_EVENT);
    }
  }

  renderAlterFlight(isReturnFlight) {
    if (this.props.alterFlight) {
      return (
        <Button
          id={`btnOverviewFlightAlterFlight-${isReturnFlight ? 'return' : 'departure'}`}
          bsStyle="change-search"
          onClick={() => {
            this.alterFlight(isReturnFlight);
          }}
          ref={c => {
            this.btnChangeFlight = c;
          }}>
          {I18n.translate('components.flightSummary.change')}
        </Button>
      );
    }
  }

  renderPlusDays(dateVariation) {
    if (dateVariation > 0) {
      let formatPlusDays = `+${dateVariation} ${I18n.translate(`components.flightTime.day`)}`;
      if (dateVariation > 1) {
        formatPlusDays = `+${dateVariation} ${I18n.translate(`components.flightTime.days`)}`;
      }
      return (
        <Row>
          <Col xs={12} className="OverviewFlight__plusDaysContainer">
            <label className="OverviewFlight__plusDays">{formatPlusDays}</label>
          </Col>
        </Row>
      );
    }
  }

  renderReturnFlightLine(isReturnFlight) {
    if (isReturnFlight) {
      return <div className="OverviewFlight__returnFlightLine" />;
    }
  }

  renderFlight(flight, isReturnFlight) {
    var connections = [];
    var flightWithConnections = <div />;
    if (flight) {
      var cabinInfare = this.getFare(flight);
      connections = flight.flight.flightGroup.map(flightGroup => {
        return this.renderConnections(flightGroup, flight.category, !flightGroup.cabinCategory ? cabinInfare : null  );
      });
      flightWithConnections = (
        <Row>
          <Col xs={12}>
            <Row>
              <Col xs={12}>{this.renderReturnFlightLine(isReturnFlight)}</Col>
            </Row>
            <Row>
              <Col xs={4} sm={6} className="text-left OverviewFlight__flightTypeContainer">
                <label className="OverviewFlight__flightType">
                  {isReturnFlight
                    ? I18n.translate('components.overviewFlight.returnFlight')
                    : I18n.translate('components.overviewFlight.departureFlight')}
                </label>
              </Col>
              <Col xs={8} sm={6} className="text-right OverviewFlight__flightDateContainer">
                <label
                  id={`overviewFlightDate-${isReturnFlight ? 'return' : 'departure'}`}
                  className="OverviewFlight__flightDate">
                  {moment(flight.flightDate, 'DD/MM/YYYY').format('ddd, D [de] MMM Y')}
                </label>

                {this.renderAlterFlight(isReturnFlight)}
              </Col>
            </Row>
            <Row>
              <Col xs={12} className="OverviewFlight__connectionsContainer">
                {connections}
              </Col>
            </Row>
          </Col>
        </Row>
      );
    }
    return flightWithConnections;
  }

  renderConnections(flight, category,fare) {
    return (
      <div
        className="OverviewFlight__connectionsContainer"
        key={flight.flightNumber + flight.origin}>
        <Row className="OverviewFlight__connectionLineContainer">
          <Col xs={4}>
            <div className="OverviewFlight__connectionLine OverviewFlight__connectionLine__left" />
          </Col>
          <Col xs={4} className="text-center">
            <label className="OverviewFlight__connection">
              {I18n.translate('components.overviewFlight.stopFlight')}
            </label>
          </Col>
          <Col xs={4}>
            <div className="OverviewFlight__connectionLine OverviewFlight__connectionLine__right" />
          </Col>
        </Row>
        <Row>
          <Col xs={6} className="text-left">
            <label
              id={`overviewFlightNumber-${flight.flightNumber}`}
              className="OverviewFlight__flightNumber">
              {I18n.translate('components.overviewFlight.flight')} {flight.operatingCarrier}{' '}
              {flight.flightNumber}
            </label>
          </Col>
          <Col xs={5} xsOffset={1} className="text-right">
            <ImageFallback
              className="OverviewFlight__marketingCarrier"
              src={`styles/img/imgVendidoPor${flight.marketingCarrier}-2.png`}
              alt={flight.marketingCarrier}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="text-left">
            <label className="OverviewFlight__category">
              {I18n.translate(`components.overviewFlight.${ this.getCategory( flight.cabinCategory? flight.cabinCategory:  fare[flight.flightNumber].cabinProduct   ).toLowerCase()  }`)}
            </label>
          </Col>
        </Row>
        <Row>
          <Col xs={6} className="text-left">
            <label className="OverviewFlight__time OverviewFlight__time__departure">
              {flight.departureTime}
            </label>
            <span> </span>
            <label className="OverviewFlight__airport">{flight.origin}</label>
            <div className="OverviewFlight__arrowIcon" />
          </Col>
          <Col xs={6} className="text-right">
            <label>
              <label className="OverviewFlight__time">{flight.arrivalTime}</label>
              <span> </span>
              <label className="OverviewFlight__airport OverviewFlight__airport__arrival">
                {flight.destination}
              </label>
            </label>
          </Col>
        </Row>
        {this.renderPlusDays(flight.dateVariation)}
      </div>
    );
  }

  getFare(flight){
    return flight.flight.recommendations !== null ? 
           flight.flight.recommendations[0].fare !== null ? 
           flight.flight.recommendations[0].fare : 
           flight.flight.recommendations[0].returnFlights[0].categories[0].fare.departure : 
           flight.flight.fare[flight.flight.prices[0].category.toLowerCase()].return
  }
  
  getCategory(cabinCategory) {
    if(cabinCategory !== 'C'){
      return 'ECONOMY'
    }
    return 'BUSINESS'
  }

  render() {
    return (
      <div id={`componentOverviewFlight-${this.props.id}`}>
        {this.renderFlight(this.props.departureFlight, false)}
        {this.renderFlight(this.props.returnFlight, true)}
      </div>
    );
  }
}

OverviewFlight.propTypes = propTypes;

export default OverviewFlight;



// WEBPACK FOOTER //
// ./src/components/overviewSearchBar/overviewFlight/OverviewFlight.jsx